import React, { useState, useCallback } from 'react';
import FormModal from './formModal';

function Result({ correctNum, length, onClick }) {
  const [showModal, toggleShowModal] = useState(false);
  const getCounter = useCallback((name) => {
    // fetch('http://localhost/digidelic/2021/bota_kentei/dist/data/count.php?timestamp=+ new Date().getTime()')
    fetch('https://www.tanabotanical.com/kentei/data/count.php?timestamp=' + new Date().getTime())
      .then((res) => res.json())
      .then(
        (result) => {
          onClick(name, result);
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          onClick(name, 'xxxxx');
        }
      );
  }, []);

  return (
    <div className="resultContent answerContent">
      <div className="resultInner answerInner">
        <p className="resultTitle">
          <img src={'assets/img/ttl-result.png'} alt="結果発表" className="ttlResult" />
        </p>
        {(!correctNum || correctNum < 4) && (
          <div className="resultDetail resultDetail01">
            <p className="resultText01">
              <img src={'assets/img/txt-result-01.png'} alt="ざんねん…！" className="txtResult" />
            </p>
            <p className="resultText02">もういちどチャレンジして満点をめざそう！</p>
            <div className="resultNumber">
              <p className="resultCorrect">
                <img src={'assets/img/number-result-' + correctNum + '.png'} alt={correctNum} className="txtResultCorrect" />
              </p>
              <p className="resultAll">
                <img src={'assets/img/txt-result-all.png'} alt="/10" className="txtResultAll" />
              </p>
              <p className="resultStamp">
                <img src={'assets/img/stamp-result-01.png'} alt="ファイト" className="stampResult" />
              </p>
            </div>
            <button onTouchStart={() => {}} className="questionBtn questionResetBtn" onClick={onClick}>
              <img src={'assets/img/btn-reset.png'} alt="もう一度" />
            </button>
          </div>
        )}
        {correctNum >= 4 && correctNum < 7 && (
          <div className="resultDetail resultDetail02">
            <p className="resultText01">
              <img src={'assets/img/txt-result-02.png'} alt="もうすこし！" className="txtResult" />
            </p>
            <p className="resultText02">もういちどチャレンジして満点をめざそう！</p>
            <div className="resultNumber">
              <p className="resultCorrect">
                <img src={'assets/img/number-result-' + correctNum + '.png'} alt={correctNum} className="txtResultCorrect" />
              </p>
              <p className="resultAll">
                <img src={'assets/img/txt-result-all.png'} alt="/10" className="txtResultAll" />
              </p>
              <p className="resultStamp">
                <img src={'assets/img/stamp-result-02.png'} alt="もう少しです" className="stampResult" />
              </p>
            </div>
            <button onTouchStart={() => {}} className="questionBtn questionResetBtn" onClick={onClick}>
              <img src={'assets/img/btn-reset.png'} alt="もう一度" />
            </button>
          </div>
        )}
        {correctNum >= 7 && correctNum < 10 && (
          <div className="resultDetail resultDetail03">
            <p className="resultText01">
              <img src={'assets/img/txt-result-03.png'} alt="おしい！" className="txtResult" />
            </p>
            <p className="resultText02">もういちどチャレンジして満点をめざそう！</p>
            <div className="resultNumber">
              <p className="resultCorrect">
                <img src={'assets/img/number-result-' + correctNum + '.png'} alt={correctNum} className="txtResultCorrect" />
              </p>
              <p className="resultAll">
                <img src={'assets/img/txt-result-all.png'} alt="/10" className="txtResultAll" />
              </p>
              <p className="resultStamp">
                <img src={'assets/img/stamp-result-03.png'} alt="あと一歩" className="stampResult" />
              </p>
            </div>
            <button onTouchStart={() => {}} className="questionBtn questionResetBtn" onClick={onClick}>
              <img src={'assets/img/btn-reset.png'} alt="もう一度" />
            </button>
          </div>
        )}
        {correctNum >= 10 && (
          <>
            <div className="resultDetail resultDetail04">
              <p className="resultText01">
                <img src={'assets/img/txt-result-04.png'} alt="おめでとう！" className="txtResult" />
              </p>
              <p className="resultText02">これでキミも植物はかせだ！</p>
              <div className="resultNumber">
                <p className="resultCorrect">
                  <img src={'assets/img/number-result-' + correctNum + '.png'} alt={correctNum} className="txtResultCorrect" />
                </p>
                <p className="resultAll">
                  <img src={'assets/img/txt-result-all.png'} alt="/10" className="txtResultAll" />
                </p>
                <p className="resultStamp">
                  <img src={'assets/img/stamp-result-04.png'} alt="たいへんよくできました" className="stampResult" />
                </p>
              </div>
              <button onTouchStart={() => {}} className="questionBtn questionResetBtn" onClick={() => toggleShowModal(true)}>
                <img src={'assets/img/btn-next2.png'} alt="次へ" />
              </button>
            </div>
            <FormModal
              showModal={showModal}
              onClose={() => {
                toggleShowModal(false);
              }}
              onClick={(name) => {
                toggleShowModal(true);
                getCounter(name);
              }}
            />
          </>
        )}
      </div>
    </div>
  );
}

export default Result;
